import { useParams } from "react-router-dom";

import JobWorkspace from "./JobWorkspace";

export default function ViewJob() {
  const { jobId } = useParams();

  return <JobWorkspace jobId={jobId!} />;
}
